import React from 'react';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import ReactTable from 'react-table';
import { connect } from 'react-redux';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import {
    getTerminationList,
    terminationColumns,
    PersonColumn,
    ReceiptContactColumn,
    createTermination,
    updateTerminationStatus,
} from './actions';
import ModalFind from '../common/ModalFind';


class TerminationList extends React.Component {
    constructor() {
        super();
        this.defaultFormState = {
            Reason_for_Termination__c: '',
            Termination_Date__c: moment(new Date()),
            Terminating_Beneficary__c: '',
        };
        this.state = {
            loading: false,
            showModal: false,
            form: this.defaultFormState,
            data: [],
            editMode: false,
        };

        this.getTerminationList = getTerminationList.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.createTermination = createTermination.bind(this);
        this.terminationColumns = terminationColumns.bind(this);
        this.updateTerminationStatus = updateTerminationStatus.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    async componentWillMount(bypass = false) {
        if (this.state.loading && (!bypass)) return;
        this.setState({ loading: true });
        try {
            const data = await this.getTerminationList();
            this.setState({ data: data.records || [], loading: false });
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'An error occured when loading termination list',
            });
            this.setState({ loading: false });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.editMode && (!prevState.editMode)) {
            this.props.updateBeneficiaryName(this.state.form.beneficiaryName);
        }
    }

    changeFormValue(attribute, value) {
        this.setState({
            form: {
                ...this.state.form,
                [attribute]: value,
            },
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            editMode: false,
            form: this.defaultFormState,
        });
        this.props.updateBeneficiaryName('');
    }

    render() {
        const filterMethod = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null && typeof row[id] === 'string') {
                const returnValue = row[id] !== undefined ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase()) : true;
                return returnValue;
            }
        };

        return (
            <div className="row">
                <div className="card list">
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-5x fa-spinner fa-spin" /> : null}
                    </p>
                    <div className="row">
                        <div className="col-lg-6 col-xs-12">
                            <h3>Beneficiary Termination</h3>
                        </div>
                        <div className="col-lg-6 col-xs-12 pull-right" style={{ textAlign: 'right' }}>
                            <button className="btn btn-danger btn-fill" onClick={() => this.setState({ showModal: true, editMode: false })}>
                                <i className="fa fa-file" /> New Termination
                            </button>
                        </div>
                    </div>
                    <ReactTable
                        data={this.state.data}
                        columns={this.terminationColumns()}
                        defaultFilterMethod={filterMethod}
                        filterable
                        sortable
                        getTdProps={() => ({
                            style: {
                                border: '1px solid #eee',
                                padding: 10,
                                fontSize: 14,
                            },
                        })}
                        defaultPageSize={10}
                    />
                    <div className="modal modal-backdrop" tabIndex="-2" role="dialog" style={{ display: this.state.showModal ? 'block' : 'none' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button
                                        onClick={this.closeModal}
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 className="modal-title">
                                        {this.state.editMode ? 'Edit Termination' : 'Create new termination'}
                                    </h4>
                                </div>
                                <div className="modal-body">
                                    <p style={{ textAlign: 'center' }}>
                                        {this.state.loading ? <i className="fa fa-2x fa-spinner fa-spin" /> : null}
                                    </p>
                                    <div className="form-group">
                                        <p>Beneficiary Name</p>
                                        <ModalFind
                                            onSelected={val => this.changeFormValue('Terminating_Beneficary__c', val.Beneficiary__c)}
                                            title="Beneficiary"
                                            isEditable={!this.state.editMode}
                                            columns={ReceiptContactColumn}
                                            shownAttribute="Beneficiary__r"
                                            shownSubAttribute="Name"
                                            siteToken={this.props.user.siteToken.hash}
                                            publicKey={this.props.user.key}
                                            fieldToSearch={['Beneficiary__r.Name', 'Beneficiary__r.ID_Number__c', 'Status__c']}
                                            extraFields="Beneficiary__c"
                                            uniqueBy="Beneficiary__c"
                                            sfTableName="Receipt__c"
                                            label={this.state.editMode ? this.state.form.beneficiaryName : ''}
                                            additionalFilter={`(Issued_By__c = '${this.props.user.loggedInUser.AccountId}' AND Status__c='Disbursed')`}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <p>Termination Reason</p>
                                        <textarea
                                            className="form-control"
                                            onChange={e => this.changeFormValue('Reason_for_Termination__c', e.target.value)}
                                            value={this.state.form.Reason_for_Termination__c}
                                        >
                                            {this.state.form.Reason_for_Termination__c}
                                        </textarea>
                                    </div>
                                    <div className="form-group">
                                        <p>Termination Date</p>
                                        <DatePicker
                                            className="form-control"
                                            selected={this.state.form.Termination_Date__c}
                                            onChange={val => this.changeFormValue('Termination_Date__c', val)}
                                            showMonthDropdown
                                            showYearDropdown
                                            dateFormat="DD/MM/YYYY"
                                            dropdownMode="select"
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button onClick={this.closeModal} className="btn btn-default">Close</button>
                                    <button
                                        onClick={async () => {
                                            // this.setState({ showModal: false });
                                            await this.createTermination();
                                        }}
                                        type="button"
                                        className="btn btn-success btn-fill"
                                    >
                                        <i className="fa fa-save" /> {this.state.editMode ? 'Update' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

TerminationList.propTypes = {
    user: PropTypes.object.isRequired,
    form: PropTypes.object.isRequired,
    updateBeneficiaryName: PropTypes.func.isRequired,
};

TerminationList.defaultProps = {

};


const mapDispatchToProps = dispatch => ({
    updateBeneficiaryName: beneficiaryName => dispatch({ type: 'UPDATE_BENEFICIARY_NAME', payload: beneficiaryName }),
});

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    form: state.form,
});
export default connect(mapStateToProps, mapDispatchToProps)(TerminationList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Termination/index.js
// module id = 985
// module chunks = 0